export const checkPromoterCookieVariable = 'check_is_promoter';
